import { render, staticRenderFns } from "./widget-date.vue?vue&type=template&id=7e61991e&scoped=true"
import script from "./widget-date.vue?vue&type=script&lang=js"
export * from "./widget-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61991e",
  null
  
)

export default component.exports